module.exports = __webpack_public_path__ + "static/media/Carbs – 1.5c8538db.jpg";